import { render, staticRenderFns } from "./InstantUser.vue?vue&type=template&id=5cc20fb7&scoped=true"
import script from "./InstantUser.vue?vue&type=script&lang=js"
export * from "./InstantUser.vue?vue&type=script&lang=js"
import style0 from "./InstantUser.vue?vue&type=style&index=0&id=5cc20fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc20fb7",
  null
  
)

export default component.exports